import React from "react";
import CustomDataTable from "../../components/CustomDataTable/CustomDataTable";
import { ENDPOINT } from "../../services/endPoints";
import { useOutlet } from "react-router-dom";

const NurseDetails = ()=>{
    const outlet = useOutlet();
    const excludedKeys = ['nurses_id', "nurses_last_name", 'nurses_national_id', 'nurses_sex', "nurses_dob", "facility_name", "facility_type", "city","nurses_role","nurses_email_id","nurses_contact","nurses_region",
    "section", "year"];

    const compareValue = ["nurses_first_name", "Foot_Forms" , "Eye_Forms", "total_referred_tests", "Rejected_forms"];

    const customKeyName = {
        nurses_first_name: "Name",
        Foot_Forms: "Foot Forms",
        Eye_Forms: "Eye Forms",
        total_referred_tests: "Total Referred Test",
        Rejected_forms: "Rejected Forms",
    };

    return (
        outlet || (
        <>
            <CustomDataTable 
                tableTitle={"Nurse Performance"}
                endPoint={ENDPOINT.NURSE_DETAILS}
                filterKey={"nurses_first_name"}
                excludedKeys={excludedKeys}
                customKeyName={customKeyName}
                compareValue={compareValue}
                // customWidth={customWidth}
                />
        </>
     )
    );
};

export default NurseDetails;